import { config } from "../config";

const TOKEN_KEY = config.tokenKey;

export function saveTokens(tokens: any) {
  sessionStorage.setItem(TOKEN_KEY, tokens);
}

export function getTokens() {
  const stringifiedToken = sessionStorage.getItem(TOKEN_KEY);

  if (!stringifiedToken) return;
  return stringifiedToken;
}

export function deleteTokens() {
  sessionStorage.removeItem(TOKEN_KEY);
}

/**
 * When a token stops being accepted, in epoch milliseconds, read from its own
 * `exp` claim. The signature is not checked — the server does that — so this
 * only ever decides to sign out early, never to let anyone in.
 *
 * Null when there is no `exp` or the token is not a readable JWT. Tokens minted
 * before the API set an expiry have none and are still accepted while the
 * backend's `allowLegacyTokensWithoutExpiry` flag is on, so the server decides.
 */
export function getTokenExpiresAt(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const { exp } = JSON.parse(atob(padded));

    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
}
export function getHeaders() {
  const token = getTokens();

  if (!token) return null;

  return {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
}
